export default __webpack_public_path__ + "93f1681259401bdde0f2d3b44ed4bf7f.png";